export const isLegalConsentAccepted = (value) => {
  return value === true || Number(value) === 1;
};
